import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/rosters')({
  component: RostersLayout,
});

function RostersLayout() {
  return <Outlet />;
}
